export default function mobileMenuFunctionality() {
  const hamburger = document.querySelector('.hamburger');
  const mobileNavMenu = document.getElementById('mobile-nav-menu');
  const navHeader = mobileNavMenu.querySelector('.nav-header');
  const menuWrapper = mobileNavMenu.querySelector('.menu');
  const menuOverlay = document.querySelector('.mobile-menu-overlay');
  const body = document.body;

  const logoSVG = `
  <svg id="Lager_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 221.6 45.2">
    <path d="M156.7,39.1c.2.2.3.4.3.7s-.1.5-.3.7-.4.3-.7.3-.5,0-.7-.3-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3.5,0,.7.3M154.5,38.3c-.4.4-.6.9-.6,1.5s.2,1.1.6,1.5.9.6,1.5.6.3,0,.5,0c-.6,1-1.4,1.6-2.3,1.9l.4,1c1.1-.4,1.9-1.1,2.6-2,.6-.9.9-1.9.9-3s-.2-1.1-.6-1.5-.9-.6-1.5-.6-1.1.2-1.5.6M145.1,43.4c-.2-.2-.3-.4-.3-.7s.1-.5.3-.7.4-.3.7-.3.5,0,.7.3.3.4.3.7-.1.5-.3.7-.4.3-.7.3-.5,0-.7-.3M147.3,44.2c.4-.4.6-.9.6-1.5s-.2-1.1-.6-1.5-.9-.6-1.5-.6-.3,0-.5,0c.6-1,1.4-1.6,2.3-1.9l-.4-1c-1.1.4-1.9,1.1-2.6,2-.6.9-.9,1.9-.9,3s.2,1.1.6,1.5.9.6,1.5.6,1.1-.2,1.5-.6M136.4,39.1c.2.2.3.4.3.7s-.1.5-.3.7-.4.3-.7.3-.5,0-.7-.3-.3-.4-.3-.7.1-.5.3-.7.4-.3.7-.3.5,0,.7.3M134.1,38.3c-.4.4-.6.9-.6,1.5s.2,1.1.6,1.5.9.6,1.5.6.3,0,.5,0c-.6,1-1.4,1.6-2.3,1.9l.4,1c1.1-.4,1.9-1.1,2.6-2,.6-.9.9-1.9.9-3s-.2-1.1-.6-1.5-.9-.6-1.5-.6-1.1.2-1.5.6M124.6,40.5l.3-.3v4.7h1.1v-7.2h-.2l-2,2,.8.8h0ZM108.6,44.8v-1.1h-2.6v-2h2.4v-1.1h-2.4v-1.8h2.6v-1.1h-3.7v7.2h3.7ZM96.8,37.7c-1,0-1.8.3-2.5,1s-1.1,1.5-1.1,2.5.3,1.8,1.1,2.5c.7.7,1.5,1,2.5,1s1.4-.2,2-.6l-.6-.8c-.4.2-.9.3-1.4.3s-1.2-.2-1.7-.7c-.5-.5-.7-1.1-.7-1.7s.2-1.2.7-1.7c.5-.5,1.1-.7,1.7-.7s1,.1,1.4.3l.6-.8c-.6-.4-1.3-.6-2-.6M83,44.8v-4.4l3.7,4.4h.4v-7.2h-1.2v4.4l-3.8-4.4h-.3v7.2s1.1,0,1.1,0ZM75.4,37.7h-1.1v7.2h1.1v-7.2ZM64.6,44.3c.4.3.8.5,1.4.5s1.1-.2,1.5-.5c.4-.3.6-.8.6-1.4s-.2-1.1-.7-1.5c-.5-.4-.9-.8-1.3-1.2-.4-.3-.6-.6-.6-.8s0-.4.2-.5c.2,0,.3-.2.5-.2s.3,0,.4,0c.1,0,.3.1.5.3l.9-.6c-.2-.2-.4-.4-.7-.6s-.7-.2-1.1-.2-.8.1-1.2.4c-.4.3-.6.7-.6,1.2s.2,1,.5,1.3c.3.3.8.7,1.3,1.1s.8.8.8,1.2,0,.5-.3.7-.4.2-.7.2-.6,0-.8-.2-.4-.3-.5-.5l-.9.5c.1.3.4.5.7.9" fill="#fff"/>
    <path d="M204.5,22.8V2.6c1.6-.5,2.9-1,5.4-.6,1.1.2,4.3,1.8,5.7,3.7s2.2,4.2,2.2,6.9-.9,6.1-2.8,7.9c-1.8,1.8-4.3,2.7-7.3,2.7s-2.5-.1-3.2-.3M208.4,24.3c5.2,0,8.9-1.6,11.3-4.8,1.3-1.8,1.9-3.9,1.9-6.4s-.3-3.4-.8-4.8c-.6-1.4-1.3-2.6-2.2-3.6-.9-.9-2-1.7-3.2-2.3-2.3-1.2-4.8-1.8-7.6-1.8h-6.8v23.7h7.5ZM170.6,20.2c-1.2-2.1-1.8-4.6-1.8-7.7s.6-4.8,1.8-6.7c1.2-2,1.9-3.5,5.1-4.2s5.8,1.1,7.2,3.3c1.3,1.9,1.9,4.5,1.9,7.7s-.6,5-1.8,7.2c-.6,1.1-1.4,2-2.5,2.7-1.1.7-2.3,1-3.7,1s-2.6-.3-3.6-.9c-1.1-.6-1.9-1.4-2.5-2.5M170.9,1.9c-1.1.6-2.2,1.4-3,2.4-.9,1-1.6,2.2-2.1,3.7-.5,1.5-.8,3.2-.8,5.1,0,3.6,1,6.5,3,8.6,2,2.1,4.6,3.1,7.7,3.1s5.9-.9,8.5-2.8c1.3-1,2.4-2.3,3.2-4.1s1.2-3.8,1.2-6.1c0-3.6-1-6.5-3.1-8.5-2-2-4.6-3.1-7.7-3.1s-4.8.6-6.9,1.7M135.6,20.2c-1.2-2.1-1.8-4.6-1.8-7.7s.6-4.8,1.8-6.7c1.2-2,1.9-3.5,5.1-4.2,3.2-.7,5.8,1.1,7.2,3.3,1.3,1.9,1.9,4.5,1.9,7.7s-.6,5-1.8,7.2c-.6,1.1-1.4,2-2.5,2.7-1.1.7-2.3,1-3.7,1s-2.6-.3-3.6-.9c-1.1-.6-1.9-1.4-2.5-2.5M136,1.9c-1.1.6-2.2,1.4-3,2.4-.9,1-1.6,2.2-2.1,3.7-.5,1.5-.8,3.2-.8,5.1,0,3.6,1,6.5,3,8.6,2,2.1,4.6,3.1,7.7,3.1s5.9-.9,8.5-2.8c1.3-1,2.4-2.3,3.2-4.1s1.2-3.8,1.2-6.1c0-3.6-1-6.5-3.1-8.5-2-2-4.6-3.1-7.7-3.1s-4.8.6-6.9,1.7M112.2,20L105.9.6h-3.9l2.8,7.5-4,12L94.4.6h-3.9l9.1,24.3h.6l5.4-14.7,5.5,14.7h.6L120.5.6h-1.8l-6.5,19.4ZM73.3,2.3c.8-.2,1.6,0,2.4,0l4.9.8.2-2.5h-18.5l.2,2.5,4.8-.8c.8,0,1.6-.2,2.4,0v22h3.5V2.3h0ZM37.9,2.5c1.6-.4,3.2-.6,4.8-.6,1.8.5,3,1.5,3.5,3,.3.7.4,1.4.4,1.9,0,3.4-2.2,5.1-6.5,5.1h-2.3V2.5ZM40.7,13l8.3,11.8,4.2-.5-9.6-11.6c2.1-.4,3.8-1.1,5-2.1,1.2-1,1.8-2.4,1.8-4.2s-.8-3.2-2.3-4.2c-1.5-1.1-3.5-1.6-5.9-1.6h-7.8v23.7h3.5v-11.3h2.8ZM9.9,4.9l4.7,11.6H5.1l4.8-11.6h0ZM1.9,24.3l2.7-6.4h10.6l2.7,6.5h3.9L11.2,0h-.5L0,24.3h1.9Z" fill="#fff"/>
    <rect y="40.8" width="51" height=".9" fill="#fff"/>
    <rect x="170.6" y="40.8" width="51" height=".9" fill="#fff"/>
  </svg>
    `;

  const closeSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><path d="M1 1L7 7M13 13L7 7M7 7L13 1L1 13" stroke="white" stroke-width="1.5" /></svg>';

  const arrowSVG = `
  <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13 1.5L7 7.5L1 1.5" stroke="#fff" stroke-width="1.5" />
  </svg>
  `;

  let menuStack = [];

  appendEverythingInLink();

  hamburger.addEventListener('click', () => {
    mobileNavMenu.classList.add('open');
    body.classList.add('no-scroll');
    initializeMenu();
    menuOverlay.classList.add('show');
    setTimeout(() => {
      menuOverlay.classList.add('animate');
    }, 0);
  });

  menuOverlay.addEventListener('click', () => {
    closeMenu();
  });

  function initializeMenu() {
    document.querySelectorAll('.primary-menu__nav .menu').forEach((menu) => {
      menu.style.transform = 'translateX(0)';
    });

    document.querySelectorAll('.menu-item-has-children .sub-menu').forEach((subMenu) => {
      subMenu.style.transform = 'translateX(100%)';
    });

    menuWrapper.addEventListener('click', handleMenuClick);

    navHeader.innerHTML = `
      <div class="header-content">
        <div class="logo-wrapper">${logoSVG}</div>
        <button class="close-button" aria-label="Close menu">${closeSVG}</button>
      </div>
    `;
    navHeader.querySelector('.close-button').addEventListener('click', closeMenu);
  }

  function appendEverythingInLink() {
    if (mobileNavMenu) {
      const maybeSubMenus = mobileNavMenu.querySelectorAll('.sub-menu');

      if (maybeSubMenus) {
        const htmlLang = document.documentElement?.lang;
        const prefix = htmlLang === 'sv-SE' ? 'Allt inom ' : 'Everything in ';

        maybeSubMenus.forEach(subMenu => {
          const prevSibling = subMenu.previousElementSibling;

          if (prevSibling && prevSibling.tagName === 'A') {
            const text = prevSibling.innerText.trim();
            const href = prevSibling.getAttribute('href');

            const newListItem = document.createElement('li');
            const newAnchor = document.createElement('a');
            newAnchor.href = href;
            newAnchor.textContent = prefix + text;
            newAnchor.classList.add('menu-item');
            newAnchor.classList.add('all-items-link');

            newListItem.appendChild(newAnchor);

            subMenu.prepend(newListItem);
          }
        });
      }
    }
  }

  function updateNavHeader(parentName) {
    navHeader.innerHTML = `
      <div class="header-content">
        ${parentName ? `<div class="back-button">${arrowSVG}</div>` : `<div class="logo-wrapper">${logoSVG}</div>`}
        ${parentName ? `<div class="parent-name">${parentName}</div>` : ''}
        <button class="close-button" aria-label="Close menu">${closeSVG}</button>
      </div>
    `;
    navHeader.querySelector('.close-button').addEventListener('click', closeMenu);
    if (parentName) {
      navHeader.querySelector('.back-button').addEventListener('click', handleBackButtonClick);
    }
  }

  function handleMenuClick(e) {
    const target = e.target;

    if (target.closest('.menu-item-has-children > a')) {
      e.preventDefault();
      const parentItem = target.closest('.menu-item-has-children');
      const subMenu = parentItem.querySelector('.sub-menu');

      if (subMenu) {
        subMenu.style.transform = 'translateX(0)';
        const parentName = parentItem.querySelector('a').textContent.trim().toLowerCase();
        updateNavHeader(parentName);
        menuStack.push(parentItem);
      }
    }

    if (target.closest('.menu-item > a') && !target.closest('.menu-item').classList.contains('menu-item-has-children')) {
      e.preventDefault();
      const itemLink = target.getAttribute('href').split('?')[0];
      window.location.href = itemLink;
    }
  }

  function handleBackButtonClick() {
    if (menuStack.length > 0) {
      const parentItem = menuStack.pop();
      const subMenu = parentItem.querySelector('.sub-menu');
      subMenu.style.transform = 'translateX(100%)';

      if (menuStack.length === 0) {
        resetToMainMenu();
      } else {
        const previousParentName = menuStack[menuStack.length - 1].querySelector('a').textContent.trim().toLowerCase();
        updateNavHeader(previousParentName);
      }
    }
  }

  function resetToMainMenu() {
    document.querySelectorAll('.primary-menu__nav .menu').forEach((menu) => {
      menu.style.transform = 'translateX(0)';
    });

    document.querySelectorAll('.menu-item-has-children .sub-menu').forEach((subMenu) => {
      subMenu.style.transform = 'translateX(100%)';
    });

    updateNavHeader(null);
  }

  function closeMenu() {
    body.classList.remove('no-scroll');
    menuOverlay.classList.remove('animate');
    setTimeout(() => {
      menuOverlay.classList.remove('show');
      mobileNavMenu.classList.remove('open');
    }, 0);
    resetMenu();
  }

  function resetMenu() {
    menuStack = [];
    resetToMainMenu();
  }
}
